import { WorkspaceUserResource } from 'dy-frontend-http-repository/lib/modules/WorkspaceUser/resources';
import domain from './domain';
import { resetWorkspaceUser } from './events';

// Workspace user information
export const $workspaceUser = domain.createStore<WorkspaceUserResource | null>(null).reset(resetWorkspaceUser);
